var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "a",
        {
          staticClass: "store-locale",
          attrs: { href: "#" },
          on: {
            click: function($event) {
              $event.preventDefault()
              return _vm.showLanguagesModal($event)
            }
          }
        },
        [_vm._v("\n    " + _vm._s(_vm.lang) + "\n  ")]
      ),
      _vm._v(" "),
      _vm.loadLanguagesModal ? _c("modal-switcher") : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }